"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.organizationViewModel = organizationViewModel;
const data_fetching_1 = require("../data-fetching/index.js");
function getOrganizationDisplayName(organization) {
    return organization.shortName || organization.abbreviation || organization.name;
}
function getOrganizationAvatar(organization, baseUrl) {
    const avatar = (0, data_fetching_1.findImageByType)(organization.images, "avatar");
    if (avatar)
        return { type: "avatar", urls: (0, data_fetching_1.resolveImageUrls)(avatar.urls, baseUrl) };
    const logo = (0, data_fetching_1.findImageByType)(organization.images, "logo");
    if (logo)
        return { type: "logo", urls: (0, data_fetching_1.resolveImageUrls)(logo.urls, baseUrl) };
    return undefined;
}
function organizationViewModel(organization, baseUrl) {
    return {
        ...organization,
        displayName: getOrganizationDisplayName(organization),
        avatar: getOrganizationAvatar(organization, baseUrl),
    };
}
